import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SectionHeader from '@/components/base/SectionHeader';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryEntries from '@/pages/home/components/CategoryEntries';
import MovieRow from '@/pages/home/components/MovieRow';
import TopicShowcase from '@/pages/home/components/TopicShowcase';
import { movies } from '@/mocks/movies';
import useDocumentMeta from '@/hooks/useDocumentMeta';

export default function Home() {
  useDocumentMeta({
    title: '免费在线观看-高清影视资源在线观看平台',
    description:
      '免费在线观看提供丰富多样的影视内容，包括最新电影、热门电视剧和综艺节目，满足用户在线观看影视的多样需求。',
    keywords: '免费在线观看,在线观看视频,免费影视,在线影视,电影观看,电视剧全集,高清影视',
  });

  const hotMovies = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 12);
  const latestMovies = [...movies]
    .sort((a, b) => b.year - a.year || b.rating - a.rating)
    .slice(0, 12);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <HeroCarousel />

        <div className="mx-auto max-w-[1440px] px-4 md:px-6 py-10 md:py-14 space-y-12 md:space-y-16">
          <section className="animate-fade-up">
            <SectionHeader
              title="浏览内容分类"
              subtitle="按电影、电视剧、综艺快速进入你想看的板块"
              icon="ri-layout-grid-line"
            />
            <CategoryEntries />
          </section>

          <section className="animate-fade-up">
            <SectionHeader
              title="热门影视推荐"
              subtitle="当季口碑与热度兼具的高分作品"
              icon="ri-fire-line"
              action={
                <Link
                  to="/category/movie"
                  className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 font-medium hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  查看更多
                  <i className="ri-arrow-right-line"></i>
                </Link>
              }
            />
            <MovieRow items={hotMovies} />
          </section>

          <section className="animate-fade-up">
            <SectionHeader
              title="最新上线影视"
              subtitle="持续更新，第一时间发现新上架内容"
              icon="ri-time-line"
              action={
                <Link
                  to="/search"
                  className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 font-medium hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  去搜索
                  <i className="ri-arrow-right-line"></i>
                </Link>
              }
            />
            <MovieRow items={latestMovies} />
          </section>

          <section id="topics" className="animate-fade-up">
            <SectionHeader
              title="影视专题推荐"
              subtitle="精心策划的主题片单，帮你发现更多好内容"
              icon="ri-bookmark-line"
            />
            <TopicShowcase />
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}